angular.module('impactx.deliverynote').controller('DeliveryNoteItemDetailCtrl', [
    '$scope',
    'TranslationService',
    'dataGen',
    '$mdDialog',
    '$timeout',
    'trns',
    'item',
    'readOnly',
    DeliveryNoteItemDetailCtrl]);

function DeliveryNoteItemDetailCtrl($scope, TranslationService, dataGen, $mdDialog, $timeout, trns, item, readOnly) {
    $scope.trns = trns;
    $scope.item = item;
    $scope.readOnly = readOnly;
    $scope.rePaint = {value: false};

    var self = this;

    if(!$scope.item.control) {
        dataGen.getData({}, {dniId: $scope.item.id}, "/deliverynote/item/controls").then(function (data) {
            $scope.item.control = data.data;
        });
    }

    this.checkRequireCtrl = function (type) {
        let ctrlElem = $scope.item.control[type];
        if (ctrlElem) {
            return ctrlElem.showMust;
        }
        return false;
    };

    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.confirm = function () {
        $mdDialog.hide({item: $scope.item});
    };
}

